import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';

export const AddEditTaxCodeForm = (strings: any, showCodeField: boolean = false): FormModel[] => {
  const nameField: FormModel = {
    label: strings.taxCode_text_name,
    value: '',
    size: 'medium',
    type: 'text',
    typeValue: 'text',
    variant: 'outlined',
    placeholder: '',
    field: 'name',
    validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
    responsive: { xs: 12, sm: 6, md: 4 },
    required: true,
  };

  const codeField: FormModel = {
    label: strings.taxCode_text_code,
    value: '',
    size: 'medium',
    type: 'text',
    typeValue: 'text',
    variant: 'outlined',
    placeholder: '',
    field: 'code',
    validators: [{ check: Validators.validateString, max: 50 }],
    responsive: { xs: 12, sm: 6, md: 4 },
    required: false,
  };

  return [
    nameField,
    ...(showCodeField ? [codeField] : []),
    {
      label: `${strings.taxCode_text_percentage} (%) `,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'percentage',
      inputProps: { min: 0, max: 100 },
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat, max: 100 }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
    {
      label: strings.taxCode_text_surcharge,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.taxCode_text_surcharge,
      field: 'surchargeResponses',
      validators: [],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: false,
      isMulti: true,
    },
  ];
};
